import styled, { css } from 'styled-components';

export const WarningContainer = styled.div`
  box-sizing: border-box;
  background: #161e23;
  color: #e6eaec;
  border: 1px solid #2c353d;
  position: absolute;

  width: 450px;
  left: 50%;
  top: 50%;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  z-index: 100;
  margin: -95px 0 0 -225px;
`;
export const Title = styled.div`
  margin: 0 0 15px;
  font-size: 20px;
  color: #e6eaec;
  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}
`;

export const Content = styled.div`
  padding: 18px;
  p {
    color: #aab2b8;
    line-height: 1.35;
  }
`;
export const Buttons = styled.div`
  margin: 15px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Block = styled.div`
  margin: 0 0 12px;
  label {
    color: #aab2b8;
    display: block;
    margin: 0 0 6px;
    font-size: 13px;
    font-weight: 500;
  }
  select,
  input {
    box-sizing: border-box;
    width: 100%;
    height: 38px;
    padding: 0 12px;
    font-family: inherit;
    font-size: 14px;
    color: #e6eaec;
    background-color: #1a2429;
    border: 1px solid #3d4952;
    border-radius: 10px;
    outline: none;
    transition: border-color 0.15s ease-in, box-shadow 0.15s ease-in;
  }
  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 34px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2 4l4 4 4-4' stroke='%23aab2b8' stroke-width='1.6' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
  }
  select option {
    background-color: #1a2429;
    color: #e6eaec;
  }
  select:focus,
  input:focus {
    border-color: #47b972;
    box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.22);
  }
  input::placeholder {
    color: #7a838a;
  }
`;
export const Fields = styled.div`
  margin: 0 0 15px;
  padding: 0 0 15px;
  border-bottom: 1px solid #2c353d;
`;
